import type { PropsWithChildren } from "react";
import type { SupportedAggregationsType } from "./SupportedAggregationsContext.ts";
import { SupportedAggregationsContext } from "./SupportedAggregationsContext.ts";

export const SupportedAggregationsContextProvider = ({
  children,
  ...props
}: PropsWithChildren<SupportedAggregationsType>) => (
  <SupportedAggregationsContext value={props}>{children}</SupportedAggregationsContext>
);
